import clsx from 'clsx';
import { cn } from '@/utils';

// #region 确认中图标
export const LoadingIcon = ({
  className,
  color = 'var(--ThemeColor-Main)',
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
    style={{ color }}
  >
    <circle cx="7" cy="7" r="5.25" stroke="currentColor" strokeWidth="1.5" opacity="0.2" />
    <path
      d="M12.25 7C12.25 4.10051 9.89949 1.75 7 1.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

// #endregion

// #region DoubleArrowUpSvg
export const DoubleArrowUpSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.64589 7.02528C6.8411 6.83007 7.15764 6.83016 7.35292 7.02528L11.5961 11.2675C11.7913 11.4626 11.7911 11.7792 11.5961 11.9745C11.4008 12.1698 11.0843 12.1698 10.8891 11.9745L6.9994 8.08583L3.11073 11.9745C2.91547 12.1698 2.59896 12.1698 2.4037 11.9745C2.20858 11.7792 2.20848 11.4627 2.4037 11.2675L6.64589 7.02528ZM6.64589 2.02528C6.8411 1.83007 7.15764 1.83016 7.35292 2.02528L11.5961 6.26747C11.7913 6.46265 11.7911 6.77922 11.5961 6.9745C11.4008 7.16976 11.0843 7.16976 10.8891 6.9745L6.9994 3.08583L3.11073 6.9745C2.91547 7.16976 2.59896 7.16976 2.4037 6.9745C2.20858 6.77923 2.20848 6.46268 2.4037 6.26747L6.64589 2.02528Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region ArrowRightSvg
export const ArrowRightSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.65422 6.08839C8.69761 6.045 8.70243 5.97764 8.66868 5.92892L8.65422 5.91161L4.58835 1.84575C4.53954 1.79693 4.46039 1.79693 4.41158 1.84575L3.79286 2.46447C3.74404 2.51328 3.74404 2.59243 3.79286 2.64124L7.15162 6L3.79286 9.35876C3.74404 9.40757 3.74404 9.48672 3.79286 9.53553L4.41158 10.1543C4.46039 10.2031 4.53954 10.2031 4.58835 10.1543L8.65422 6.08839Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region ChevronDownSvg
export const ChevronDownSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      d="M2.5 4L5 6.5L7.5 4"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
// #endregion

// #region CloseSvg
export const CloseSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M1.42259 0.244075C1.09715 -0.0813583 0.569517 -0.0813583 0.244075 0.244075C-0.0813583 0.569517 -0.0813583 1.09715 0.244075 1.42259L5.05634 6.23484L0.244125 11.0471C-0.0813083 11.3725 -0.0813083 11.9002 0.244125 12.2256C0.569567 12.551 1.0972 12.551 1.42263 12.2256L6.23484 7.41334L11.0471 12.2256C11.3725 12.551 11.9002 12.551 12.2256 12.2256C12.551 11.9002 12.551 11.3725 12.2256 11.0471L7.41334 6.23484L12.2257 1.42259C12.5511 1.09715 12.5511 0.569517 12.2257 0.244075C11.9003 -0.0813583 11.3726 -0.0813583 11.0472 0.244075L6.23484 5.05634L1.42259 0.244075Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 首充邀请特权 - 呼朋唤友
/** 首充邀请特权 - 呼朋唤友 */
export const InviteFriendsSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <g clipPath="url(#clip0_invite_friends)">
      <g clipPath="url(#clip1_invite_friends)">
        <path
          d="M5 9C5.26522 9 5.51957 9.10536 5.70711 9.29289C5.89464 9.48043 6 9.73478 6 10C7.57114 9.99769 9.09698 10.5263 10.33 11.5H12.5C13.833 11.5 15.03 12.08 15.854 13H19C19.9453 12.9997 20.8712 13.2674 21.6705 13.772C22.4698 14.2767 23.1097 14.9975 23.516 15.851C21.151 18.972 17.322 21 13 21C10.21 21 7.85 20.397 5.94 19.342C5.87004 19.5351 5.74224 19.7018 5.57402 19.8196C5.40579 19.9374 5.20534 20.0003 5 20H2C1.73478 20 1.48043 19.8946 1.29289 19.7071C1.10536 19.5196 1 19.2652 1 19V10C1 9.73478 1.10536 9.48043 1.29289 9.29289C1.48043 9.10536 1.73478 9 2 9H5ZM6.001 12L6 17.022L6.045 17.054C7.84 18.314 10.178 19 13 19C16.004 19 18.799 17.844 20.835 15.87L20.968 15.737L20.848 15.637C20.3758 15.2672 19.8034 15.0477 19.205 15.007L19 15H16.889C16.961 15.322 17 15.656 17 16V17H8V15L14.79 14.999L14.756 14.921C14.5644 14.5205 14.2696 14.1783 13.9019 13.9295C13.5343 13.6806 13.107 13.5341 12.664 13.505L12.5 13.5H9.57C9.10531 13.0247 8.55027 12.6472 7.93752 12.3896C7.32477 12.132 6.66569 11.9995 6.001 12ZM4 11H3V18H4V11ZM18 5C18.7956 5 19.5587 5.31607 20.1213 5.87868C20.6839 6.44129 21 7.20435 21 8C21 8.79565 20.6839 9.55871 20.1213 10.1213C19.5587 10.6839 18.7956 11 18 11C17.2044 11 16.4413 10.6839 15.8787 10.1213C15.3161 9.55871 15 8.79565 15 8C15 7.20435 15.3161 6.44129 15.8787 5.87868C16.4413 5.31607 17.2044 5 18 5ZM18 7C17.7348 7 17.4804 7.10536 17.2929 7.29289C17.1054 7.48043 17 7.73478 17 8C17 8.26522 17.1054 8.51957 17.2929 8.70711C17.4804 8.89464 17.7348 9 18 9C18.2652 9 18.5196 8.89464 18.7071 8.70711C18.8946 8.51957 19 8.26522 19 8C19 7.73478 18.8946 7.48043 18.7071 7.29289C18.5196 7.10536 18.2652 7 18 7ZM11 2C11.7956 2 12.5587 2.31607 13.1213 2.87868C13.6839 3.44129 14 4.20435 14 5C14 5.79565 13.6839 6.55871 13.1213 7.12132C12.5587 7.68393 11.7956 8 11 8C10.2044 8 9.44129 7.68393 8.87868 7.12132C8.31607 6.55871 8 5.79565 8 5C8 4.20435 8.31607 3.44129 8.87868 2.87868C9.44129 2.31607 10.2044 2 11 2ZM11 4C10.7348 4 10.4804 4.10536 10.2929 4.29289C10.1054 4.48043 10 4.73478 10 5C10 5.26522 10.1054 5.51957 10.2929 5.70711C10.4804 5.89464 10.7348 6 11 6C11.2652 6 11.5196 5.89464 11.7071 5.70711C11.8946 5.51957 12 5.26522 12 5C12 4.73478 11.8946 4.48043 11.7071 4.29289C11.5196 4.10536 11.2652 4 11 4Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_invite_friends">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_invite_friends">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// #endregion

// #region 首充邀请特权 - +888元（短）
/** 首充邀请特权 - +888元（短） */
export const Plus888YuanSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="14"
    viewBox="0 0 65 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M6.15625 5.5H9.90625V7.6875H6.15625V11.4375H3.8125V7.6875H0V5.5H3.8125V1.6875H6.15625V5.5ZM15.0625 5.375H19.7188V3H15.0625V5.375ZM19.7188 7.53125H15.0625V10.125H19.7188V7.53125ZM22.125 12.2188H12.6562V0.84375H22.125V12.2188ZM27.5938 5.375H32.25V3H27.5938V5.375ZM32.25 7.53125H27.5938V10.125H32.25V7.53125ZM34.6562 12.2188H25.1875V0.84375H34.6562V12.2188ZM40.125 5.375H44.7812V3H40.125V5.375ZM44.7812 7.53125H40.125V10.125H44.7812V7.53125ZM47.1875 12.2188H37.7188V0.84375H47.1875V12.2188ZM50.0938 2.125V0H63.3438V2.125H50.0938ZM64.375 9.53125L63.5312 13.2031H58.375V7H54.9688L51.8125 13.3281H49.3438L52.4688 7H49.5625V4.875H63.9375V7H60.6875V11.125H61.8125L62.1875 9.53125H64.375Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 首充邀请特权 - 100人=15万
/** 首充邀请特权 - 100人=15万 */
export const HundredPeople15WanSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="14"
    viewBox="0 0 96 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M4.1875 12.5312H1.75V3.34375H0V1.15625H4.1875V12.5312ZM10.8438 10.3438H15.3125V3.375H10.8438V10.3438ZM17.75 12.5312H8.40625V1.15625H17.75V12.5312ZM23 10.3438H27.4688V3.375H23V10.3438ZM29.9062 12.5312H20.5625V1.15625H29.9062V12.5312ZM40.4375 0V5.5L46.7812 13.6406H43.8125L39.25 7.71875L34.8125 13.6406H31.9062L38.125 5.4375V0H40.4375ZM58.4375 9.53125H48.5312V7.34375H58.4375V9.53125ZM58.4375 6.4375H48.5312V4.25H58.4375V6.4375ZM65.0625 12.5312H62.625V3.34375H60.875V1.15625H65.0625V12.5312ZM76.3438 7.875H69.3125V1.15625H78.75V3.3125H71.7188V5.75H78.75V12.5312H69.3125V10.4062H76.3438V7.875ZM81.25 0.3125H95.3125V2.4375H86.2188L86.0938 4.5H94.7188L94.375 13.6406H88.0312V11.5625H92.0625L92.3125 6.625H85.8125L83.3125 13.6406H80.9375L83.75 5.625L84 2.4375H81.25V0.3125Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 首充邀请特权 - 无上限
/** 首充邀请特权 - 无上限 */
export const UnlimitedSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="14"
    viewBox="0 0 47 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M8.75 13.6094V7.65625H6.96875L2.6875 13.6094H0L4.1875 7.65625H0.5V5.53125H5.5L6.125 2.46875H1.0625V0.34375H14V2.46875H8.4375L7.875 5.53125H14.625V7.65625H11.0625V11.5312H12.3438L12.875 9.84375H15.2188L14.3438 13.6094H8.75ZM24.125 0V3.8125H30.25V5.9375H24.125V11.4688H30.6875V13.5781H16.4375V11.4688H21.8125V0H24.125ZM46.875 11L46 11.4375L46.9375 13.6406H44.4688L42.0938 8.25H41.125V10.8125L42.875 10.25V12.5312L38.4062 13.7656V11.5938L38.8438 11.4688V0.1875H46.5938V8.25H44.5312L45.0312 9.375L46.875 8.40625V11ZM34.6875 2.375V13.6406H32.5V0.25H38.5312L37.1875 5.375H37.875V12.9219H35.1562V10.8125H35.7188V6.375H34.8125L35.9062 2.375H34.6875ZM41.125 2.3125V3.21875H44.3125V2.3125H41.125ZM44.3125 6.125V5.28125H41.125V6.125H44.3125Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 首充邀请特权 - 累计奖励
/** 首充邀请特权 - 累计奖励 */
export const CumulativeRewardSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <g clipPath="url(#clip0_cumulative_reward)">
      <g clipPath="url(#clip1_cumulative_reward)">
        <path
          d="M2 13H8V21H2V13ZM16 8H22V21H16V8ZM9 3H15V21H9V3ZM4 15V19H6V15H4ZM11 5V19H13V5H11ZM18 10V19H20V10H18Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_cumulative_reward">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_cumulative_reward">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// #endregion

// #region 首充邀请特权 - 好友升级
/** 首充邀请特权 - 好友升级 */
export const FriendUpgradeSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path d="M13 11V17H11V11H8L12 7L16 11H13Z" fill="currentColor" />
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
  </svg>
);
// #endregion

// #region 首充邀请特权 - 最高VIP5
/** 首充邀请特权 - 最高VIP5 */
export const MaxVip5Svg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="75"
    height="14"
    viewBox="0 0 75 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M0.625 0.25H14V5.5H0.625V0.25ZM7.875 7.59375V11.1875L8.3125 11.1562V12.6094L7.875 12.6719V13.6406H5.5625V13.0469L0 13.4844V11.9375L0.625 11.875V7.59375H0V5.96875H14.625V7.59375H7.875ZM8.8125 11.7812L9.4375 11.4688V9.84375L11.125 10.5625L12.2188 10V9.71875H8.625V8.0625H14.25V10.8438L13.125 11.4375L14.4688 12.0312V13.7031L11.3438 12.375L8.8125 13.7031V11.7812ZM2.9375 2.21875H11.6875V1.65625H2.9375V2.21875ZM11.6875 3.53125H2.9375V4.09375H11.6875V3.53125ZM5.5625 9.34375H2.9375V9.84375H5.5625V9.34375ZM2.9375 8.09375H5.5625V7.59375H2.9375V8.09375ZM2.9375 11.1562V11.6562L5.5625 11.4688V11.1562H2.9375ZM16.8125 2.84375H29.8125V6.59375H16.8125V2.84375ZM28 11.875V8.875H18.6875V13.6406H16.4375V7.09375H30.25V13.6406H27.625V11.875H28ZM30.3125 2.34375H16.375V0.5625H22.0625L21.8125 0H24.375L24.625 0.5625H30.3125V2.34375ZM27.5625 4.40625H19.0625V5.03125H27.5625V4.40625ZM21.4688 10.8438V11.3438H25.0625V10.8438H21.4688ZM27.3125 9.34375V12.8594H19.2188V9.34375H27.3125ZM42.8125 0.875L38.5938 12.5312H36.1562L32.0938 0.875H34.6562L37.4375 8.9375L40.25 0.875H42.8125ZM48.875 12.5312H46.4688V0.875H48.875V12.5312ZM55.375 8.28125V12.5312H52.9688V0.875H62.4375V8.28125H55.375ZM55.375 6.03125H60.0312V3.09375H55.375V6.03125ZM72.3438 7.875H65.3125V1.15625H74.75V3.3125H67.7188V5.75H74.75V12.5312H65.3125V10.4062H72.3438V7.875Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 首充邀请特权 - 返水奖励
/** 首充邀请特权 - 返水奖励 */
export const RebateRewardSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <g clipPath="url(#clip0_rebate_reward)">
      <path
        d="M15 2.50001C15.7023 2.49992 16.3922 2.68474 17.0004 3.03587C17.6086 3.387 18.1137 3.89207 18.4647 4.5003C18.8158 5.10853 19.0006 5.79847 19.0005 6.50075C19.0003 7.20304 18.8153 7.89291 18.464 8.50101L23 8.50001V10.5H21V20.5C21 20.7652 20.8946 21.0196 20.7071 21.2071C20.5196 21.3946 20.2652 21.5 20 21.5H4C3.73478 21.5 3.48043 21.3946 3.29289 21.2071C3.10536 21.0196 3 20.7652 3 20.5V10.5H1V8.50001L5.536 8.50101C5.03986 7.64189 4.88069 6.62906 5.08938 5.65918C5.29808 4.6893 5.85975 3.83157 6.66533 3.25256C7.47092 2.67354 8.46293 2.41456 9.44875 2.52588C10.4346 2.63721 11.3438 3.11091 12 3.85501C12.3746 3.42839 12.8361 3.08678 13.3535 2.85308C13.8709 2.61939 14.4323 2.49901 15 2.50001ZM11 10.5H5V19.5H11V10.5ZM19 10.5H13V19.5H19V10.5ZM9 4.50001C8.48102 4.49768 7.98145 4.69719 7.60685 5.05639C7.23224 5.41558 7.01193 5.90632 6.99246 6.42495C6.97299 6.94357 7.15588 7.44945 7.50249 7.83572C7.84911 8.222 8.3323 8.4584 8.85 8.49501L9 8.50001H11V6.50001C11 6.02207 10.8289 5.55992 10.5176 5.19726C10.2063 4.83461 9.77542 4.59541 9.303 4.52301L9.149 4.50501L9 4.50001ZM15 4.50001C14.4954 4.49985 14.0094 4.69041 13.6395 5.0335C13.2695 5.37659 13.0428 5.84685 13.005 6.35001L13 6.50001V8.50001H15C15.5046 8.50017 15.9906 8.3096 16.3605 7.96651C16.7305 7.62342 16.9572 7.15316 16.995 6.65001L17 6.50001C17 5.96957 16.7893 5.46087 16.4142 5.08579C16.0391 4.71072 15.5304 4.50001 15 4.50001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_rebate_reward">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// #endregion

// #region 激活邀请特权 - 荐，文字
/** 激活邀请特权 - 荐，文字 */
export const ActivateInviteButtonTextSvg = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M11.2188 10.7812H4.28125V8.78125H9.15625L10.0312 8.28125H4.71875V6.28125H14.6875V7.625L12.5625 8.78125H15.0312V10.7812H13.5312V13.6406H5.71875V11.6875H11.2188V10.7812ZM4.4375 5.78125L3.15625 7.65625H3.8125V13.6406H1.5625V8.46875H0L1.8125 5.78125H1.0625V3.78125H2.96875L3.28125 3.375H5.875L5.5625 3.78125H15V5.78125H4.4375ZM9.875 0H12.1875V0.59375H15.0625V2.5625H12.1875V3.21875H9.875V2.5625H6.25V3.0625H3.9375V2.5625H0.9375V0.59375H3.9375V0H6.25V0.59375H9.875V0Z"
      fill="var(--Green-300)"
    />
  </svg>
);
// #endregion

// #region CopySvg
export const CopySvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <g clipPath="url(#clip0_8652_8665)">
      <mask id="path-1-inside-1_8652_8665" fill="white">
        <rect x="1.75" y="3.5" width="7.58333" height="9.33333" rx="0.583333" />
      </mask>
      <rect
        x="1.75"
        y="3.5"
        width="7.58333"
        height="9.33333"
        rx="0.583333"
        stroke="currentColor"
        strokeWidth="2.33333"
        mask="url(#path-1-inside-1_8652_8665)"
      />
      <path
        d="M11.6665 1.16602C11.9886 1.16602 12.2493 1.42701 12.2495 1.74902V9.91602C12.2495 10.218 12.0201 10.4662 11.7261 10.4961L11.6665 10.499H9.9165V9.33301H11.0835V2.33301H5.8335V2.91602H4.6665V1.74902C4.66668 1.42712 4.9276 1.16619 5.24951 1.16602H11.6665Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_8652_8665">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// #endregion

// #region Op7LogoSvg
export const Op7LogoSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="24"
    viewBox="0 0 64 24"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M12.3438 0.00390625C18.8459 0.16823 24.0664 5.47616 24.0664 12L24.0625 12.3096C23.8979 18.7939 18.5751 23.9999 12.0332 24L11.7227 23.9961C5.22044 23.8319 0 18.5239 0 12C0 5.37258 5.38751 0 12.0332 0L12.3438 0.00390625ZM37.1104 1.2002C38.4868 1.2002 39.7069 1.49096 40.7705 2.07324C41.8341 2.63478 42.6582 3.43574 43.2422 4.47559C43.8262 5.49479 44.1182 6.67075 44.1182 8.00195C44.1181 9.37458 43.8261 10.5812 43.2422 11.6211C42.679 12.6609 41.8654 13.4619 40.8018 14.0234C39.7381 14.5849 38.5076 14.8652 37.1104 14.8652H29.4141V20.8867C29.4141 21.677 29.1635 22.2803 28.6631 22.6963C28.1625 23.1123 27.4321 23.3203 26.4727 23.3203V2.57227C26.4728 2.17728 26.6088 1.85497 26.8799 1.60547C27.1718 1.33516 27.5367 1.20023 27.9746 1.2002H37.1104ZM61.8184 1.2002C62.2562 1.20026 62.6004 1.31424 62.8506 1.54297C63.1009 1.77177 63.2256 2.07385 63.2256 2.44824C63.2255 2.69772 63.1736 2.92685 63.0693 3.13477L53.4023 22.1973C53.027 22.946 52.4532 23.3202 51.6816 23.3203C51.0351 23.3203 50.4615 23.1436 49.9609 22.79L59.6279 3.75879H48.834C48.125 3.75873 47.572 3.54022 47.1758 3.10352C46.8004 2.66676 46.6133 2.03206 46.6133 1.2002H61.8184ZM12.0332 2.52734C6.77667 2.52734 2.52734 6.77486 2.52734 12C2.52734 17.2251 6.77667 21.4727 12.0332 21.4727C17.2897 21.4726 21.5391 17.2251 21.5391 12C21.5391 6.7749 17.2897 2.52741 12.0332 2.52734ZM10.2754 16.832L10.6182 17.0068C10.9069 17.1542 11.226 17.3097 11.5088 17.4648L11.5215 17.4746L11.5225 17.4893C10.786 18.5697 9.6564 19.1139 8.36328 19.0908L8.46387 18.4873C8.5115 18.1602 8.57405 17.7989 8.63086 17.4727C9.05262 17.2437 9.49149 17.0373 9.91602 16.8125C9.96828 16.7848 10.0234 16.7564 10.0781 16.7344C10.1355 16.7576 10.2185 16.803 10.2754 16.832ZM6.92773 16.4648L7.38184 16.918L7.62988 17.165C7.68193 17.2172 7.74049 17.2737 7.78516 17.332C7.79805 17.3491 7.79607 17.3718 7.79297 17.3936C7.76778 17.5684 7.73675 17.7475 7.70801 17.9219L7.53711 18.957C7.14693 18.8486 6.86285 18.7147 6.52246 18.501C5.91563 18.0855 5.47264 17.5598 5.18457 16.8799C5.12223 16.7328 5.09085 16.6062 5.03711 16.4629C5.15927 16.4476 5.31459 16.4169 5.43848 16.3965L6.21875 16.2676C6.29621 16.2546 6.61222 16.1955 6.66406 16.2031C6.75006 16.281 6.84478 16.382 6.92773 16.4648ZM11.3682 13.2256C11.5366 13.4454 11.6583 13.6326 11.7803 13.8838C12.1402 14.6259 12.2368 15.4699 12.0518 16.2754C12.014 16.4413 11.9707 16.5667 11.915 16.7275L11.5498 16.542C11.1944 16.3658 10.815 16.1544 10.4609 15.9883C10.3845 15.5774 10.3376 15.1543 10.2646 14.7422C10.2442 14.6262 10.2228 14.5025 10.209 14.3857C10.2973 14.2821 10.498 14.0927 10.6016 13.9893L11.3682 13.2256ZM7.97754 14.3926C8.0472 14.3833 8.41498 14.4484 8.5127 14.4639L9.37109 14.5996C9.41262 14.6361 9.42237 14.776 9.43164 14.835L9.49121 15.2207L9.57324 15.7402C9.58704 15.8282 9.60798 15.9404 9.61621 16.0273L8.33398 16.6846C8.17501 16.5369 8.00091 16.3535 7.8457 16.1982L7.31348 15.6631C7.47371 15.3729 7.6178 15.0649 7.77246 14.7715C7.81628 14.6883 7.92913 14.4514 7.97754 14.3926ZM6.51758 12.4746C6.68484 12.773 6.83985 13.1063 7.00293 13.4102C7.05161 13.5008 7.23542 13.8443 7.2627 13.9268C7.19054 14.0953 7.08329 14.2824 6.99902 14.4482C6.84427 14.7527 6.68957 15.0593 6.53027 15.3613C6.47431 15.3811 6.26935 15.4119 6.20215 15.4229L5.53516 15.5312C5.34208 15.5635 5.09457 15.5963 4.90918 15.6377C4.88876 15.262 4.94405 14.8364 5.04883 14.4756C5.24516 13.7966 5.63731 13.1892 6.17578 12.7305C6.26975 12.6504 6.40979 12.5341 6.51758 12.4746ZM7.26367 12.0859C8.388 11.6506 9.80081 11.8411 10.7373 12.6064C10.7448 12.6114 10.7547 12.6207 10.7617 12.627L10.7607 12.6426C10.7284 12.6901 9.69001 13.7297 9.62598 13.7744C9.60787 13.7866 9.56833 13.7815 9.54688 13.7793C9.32057 13.756 9.0912 13.7082 8.86621 13.6729C8.58123 13.6281 8.29176 13.5915 8.00879 13.5361C7.9778 13.4555 7.87009 13.2608 7.82715 13.1777L7.46875 12.4834L7.26367 12.0859ZM29.4141 12.2764H37.1104C38.3618 12.2764 39.352 11.9011 40.082 11.1523C40.812 10.3828 41.1777 9.33295 41.1777 8.00195C41.1777 6.71236 40.8016 5.69314 40.0508 4.94434C39.3208 4.17475 38.3409 3.78908 37.1104 3.78906H29.4141V12.2764Z"
      fill="#1A81FF"
    />
  </svg>
);
// #endregion

// #region 加入合营 - 标题 背景图 pc使用
/** 加入合营 - 标题 背景图 pc使用 */
export const PartnershipTitleSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="165"
    height="21"
    viewBox="0 0 165 21"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M30.4668 8H148.852L161.742 20.0312H164.742L149.742 6.03125H149.578V6H29.5781L30.4668 8ZM0 2H148.25L145.841 0H0V2Z"
      fill="url(#paint0_linear_6810_201493)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6810_201493"
        x1="15.9059"
        y1="10.0156"
        x2="165.538"
        y2="10.0156"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity="0" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
    </defs>
  </svg>
);
// #endregion

// #region 加入合营 - 标题 背景图 短版 pc使用
/** 加入合营 - 标题 背景图 短版 pc使用 */
export const PartnershipTitleShortSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="104"
    height="21"
    viewBox="0 0 104 21"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M9.2168 8H87.6016L100.492 20.0312H103.492L88.4922 6.03125H88.3281V6H8.32812L9.2168 8ZM0 2H87L84.5908 0H0V2Z"
      fill="url(#paint0_linear_6807_201395)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6807_201395"
        x1="9.99219"
        y1="10.0156"
        x2="103.992"
        y2="10.0156"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity="0" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
    </defs>
  </svg>
);
// #endregion

// #region ArrowLeftSvg
export const ArrowLeftSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    className={clsx('shrink-0', className)}
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.05098 4.90179C2.00277 4.95 1.99741 5.02484 2.03491 5.07897L2.05098 5.09821L6.56861 9.61584C6.62284 9.67008 6.71078 9.67008 6.76502 9.61584L7.45249 8.92837C7.50673 8.87413 7.50673 8.78619 7.45249 8.73195L3.72054 5L7.45249 1.26805C7.50673 1.21381 7.50673 1.12587 7.45249 1.07163L6.76502 0.384164C6.71078 0.329925 6.62284 0.329925 6.56861 0.384164L2.05098 4.90179Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 联系客服
/** 联系客服  */
export const CustomerServiceHeadsetSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 12 12"
    fill="none"
    className={clsx('shrink-0', className)}
    aria-hidden
  >
    <g clipPath="url(#clip0_customer_service_headset)">
      <path
        d="M9.969 3.99946H10.5C10.7652 3.99946 11.0196 4.10482 11.2071 4.29236C11.3946 4.47989 11.5 4.73425 11.5 4.99946V6.99946C11.5 7.26468 11.3946 7.51903 11.2071 7.70657C11.0196 7.8941 10.7652 7.99946 10.5 7.99946H9.969C9.84711 8.96611 9.37663 9.85505 8.64587 10.4995C7.91512 11.1439 6.97431 11.4994 6 11.4995V10.4995C6.79565 10.4995 7.55871 10.1834 8.12132 9.62078C8.68393 9.05817 9 8.29511 9 7.49946V4.49946C9 3.70381 8.68393 2.94075 8.12132 2.37814C7.55871 1.81553 6.79565 1.49946 6 1.49946C5.20435 1.49946 4.44129 1.81553 3.87868 2.37814C3.31607 2.94075 3 3.70381 3 4.49946V7.99946H1.5C1.23478 7.99946 0.98043 7.8941 0.792893 7.70657C0.605357 7.51903 0.5 7.26468 0.5 6.99946V4.99946C0.5 4.73425 0.605357 4.47989 0.792893 4.29236C0.98043 4.10482 1.23478 3.99946 1.5 3.99946H2.031C2.15302 3.03291 2.62354 2.1441 3.35429 1.4998C4.08503 0.855501 5.02578 0.5 6 0.5C6.97422 0.5 7.91497 0.855501 8.64571 1.4998C9.37646 2.1441 9.84698 3.03291 9.969 3.99946ZM1.5 4.99946V6.99946H2V4.99946H1.5ZM10 4.99946V6.99946H10.5V4.99946H10ZM3.88 7.89196L4.41 7.04396C4.88654 7.34248 5.43768 7.50037 6 7.49946C6.56232 7.50037 7.11346 7.34248 7.59 7.04396L8.12 7.89196C7.48463 8.29003 6.74977 8.50061 6 8.49946C5.25023 8.50061 4.51537 8.29003 3.88 7.89196Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_customer_service_headset">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// #endregion

// #region 编辑图标
/** 编辑图标 */
export const EditSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M10.2816 2.28567V3.42853C10.2816 3.44729 10.2779 3.46586 10.2708 3.4832C10.2636 3.50053 10.2531 3.51628 10.2398 3.52954C10.2265 3.54281 10.2108 3.55333 10.1934 3.56051C10.1761 3.56769 10.1575 3.57138 10.1388 3.57138H4.28592C4.11873 3.57132 3.95683 3.6299 3.82839 3.73693C3.69996 3.84396 3.61314 3.99265 3.58305 4.1571L3.57162 4.28567V15.7142C3.57156 15.8814 3.63015 16.0433 3.73717 16.1717C3.8442 16.3002 3.99289 16.387 4.15734 16.4171L4.28592 16.4285H15.7145C15.8816 16.4286 16.0435 16.37 16.172 16.263C16.3004 16.1559 16.3872 16.0072 16.4173 15.8428L16.4288 15.7142V9.51421C16.4288 9.47632 16.4438 9.43999 16.4706 9.4132C16.4974 9.38641 16.5337 9.37136 16.5716 9.37136H17.7145C17.7332 9.37136 17.7518 9.37505 17.7691 9.38223C17.7865 9.3894 17.8022 9.39993 17.8155 9.41319C17.8287 9.42646 17.8393 9.4422 17.8464 9.45954C17.8536 9.47687 17.8573 9.49545 17.8573 9.51421V15.7142C17.8573 16.2469 17.6589 16.7605 17.3007 17.1548C16.9426 17.5491 16.4504 17.7959 15.9202 17.8471L15.7145 17.8571H4.28594C3.75324 17.8571 3.23966 17.6586 2.84533 17.3005C2.451 16.9423 2.2042 16.4502 2.15307 15.9199L2.14307 15.7142V4.28569C2.14309 3.753 2.34152 3.23941 2.69966 2.84508C3.0578 2.45075 3.54998 2.20396 4.08021 2.15282L4.28594 2.14282H10.1388C10.1576 2.14282 10.1761 2.14652 10.1935 2.1537C10.2108 2.16088 10.2265 2.1714 10.2398 2.18467C10.2531 2.19794 10.2636 2.21369 10.2708 2.23102C10.2779 2.24835 10.2816 2.26691 10.2816 2.28567ZM16.2845 2.9071L17.0931 3.71567C17.1197 3.74244 17.1346 3.77865 17.1346 3.81639C17.1346 3.85413 17.1197 3.89033 17.0931 3.9171L8.20303 12.8071C8.17626 12.8337 8.14005 12.8486 8.10231 12.8486C8.06457 12.8486 8.02837 12.8337 8.0016 12.8071L7.19303 11.9985C7.16643 11.9717 7.15149 11.9355 7.15149 11.8978C7.15149 11.8601 7.16643 11.8239 7.19303 11.7971L16.083 2.9071C16.1098 2.88049 16.146 2.86556 16.1837 2.86556C16.2215 2.86556 16.2577 2.88049 16.2845 2.9071Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
    />
  </svg>
);
// #endregion

// #region 更多，三个点图标
/** 更多，三个点图标 */
export const ThreeDotsSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M2.5 10C2.5 10.3978 2.65804 10.7794 2.93934 11.0607C3.22064 11.342 3.60218 11.5 4 11.5C4.39783 11.5 4.77936 11.342 5.06066 11.0607C5.34196 10.7794 5.5 10.3978 5.5 10C5.5 9.60218 5.34196 9.22064 5.06066 8.93934C4.77936 8.65804 4.39783 8.5 4 8.5C3.60218 8.5 3.22064 8.65804 2.93934 8.93934C2.65804 9.22064 2.5 9.60218 2.5 10Z"
      fill="currentColor"
    />
    <path
      d="M8.5 10C8.5 10.3978 8.65804 10.7794 8.93934 11.0607C9.22064 11.342 9.60218 11.5 10 11.5C10.3978 11.5 10.7794 11.342 11.0607 11.0607C11.342 10.7794 11.5 10.3978 11.5 10C11.5 9.80302 11.4612 9.60796 11.3858 9.42598C11.3104 9.24399 11.1999 9.07863 11.0607 8.93934C10.9214 8.80005 10.756 8.68956 10.574 8.61418C10.392 8.5388 10.197 8.5 10 8.5C9.80302 8.5 9.60796 8.5388 9.42598 8.61418C9.24399 8.68956 9.07863 8.80005 8.93934 8.93934C8.80005 9.07863 8.68956 9.24399 8.61418 9.42598C8.5388 9.60796 8.5 9.80302 8.5 10Z"
      fill="currentColor"
    />
    <path
      d="M14.5 10C14.5 10.3978 14.658 10.7794 14.9393 11.0607C15.2206 11.342 15.6022 11.5 16 11.5C16.3978 11.5 16.7794 11.342 17.0607 11.0607C17.342 10.7794 17.5 10.3978 17.5 10C17.5 9.60218 17.342 9.22064 17.0607 8.93934C16.7794 8.65804 16.3978 8.5 16 8.5C15.6022 8.5 15.2206 8.65804 14.9393 8.93934C14.658 9.22064 14.5 9.60218 14.5 10Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 圆圈+感叹号，提示icon，感叹号向下
/** 圆圈+感叹号， 提示icon，感叹号向下 */
export const CircleTipDownSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M7.99981 15.3329C3.95606 15.3329 0.666992 12.0438 0.666992 8.00005C0.666992 3.9563 3.95606 0.667236 7.99981 0.667236C12.0436 0.667236 15.3326 3.9563 15.3326 8.00005C15.3326 12.0438 12.0436 15.3329 7.99981 15.3329ZM7.99981 2.00005C4.69199 2.00005 1.9998 4.69224 1.9998 8.00005C1.9998 11.3079 4.69199 14.0001 7.99981 14.0001C11.3076 14.0001 13.9998 11.3079 13.9998 8.00005C13.9998 4.69224 11.3076 2.00005 7.99981 2.00005Z"
      fill="currentColor"
    />
    <path
      d="M7.33301 11.3328C7.33301 11.5098 7.4033 11.6795 7.52842 11.8046C7.65354 11.9297 7.82325 12 8.0002 12C8.17714 12 8.34685 11.9297 8.47197 11.8046C8.59709 11.6795 8.66738 11.5098 8.66738 11.3328C8.66738 11.1559 8.59709 10.9862 8.47197 10.8611C8.34685 10.7359 8.17714 10.6656 8.0002 10.6656C7.82325 10.6656 7.65354 10.7359 7.52842 10.8611C7.4033 10.9862 7.33301 11.1559 7.33301 11.3328Z"
      fill="currentColor"
    />
    <path
      d="M7.34961 9V4.5C7.34961 4.14101 7.64101 3.84961 8 3.84961C8.35899 3.84961 8.65039 4.14101 8.65039 4.5V9C8.65039 9.35898 8.35899 9.65039 8 9.65039C7.64101 9.65039 7.34961 9.35898 7.34961 9Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 圆圈+问号
/** 圆圈+问号  */
export const CircleQuestionSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M7.0002 13.4162C3.46191 13.4162 0.583984 10.5382 0.583984 6.99995C0.583984 3.46167 3.46191 0.58374 7.0002 0.58374C10.5385 0.58374 13.4164 3.46167 13.4164 6.99995C13.4164 10.5382 10.5385 13.4162 7.0002 13.4162ZM7.0002 1.74995C4.10586 1.74995 1.7502 4.10562 1.7502 6.99995C1.7502 9.89429 4.10586 12.25 7.0002 12.25C9.89453 12.25 12.2502 9.89429 12.2502 6.99995C12.2502 4.10562 9.89453 1.74995 7.0002 1.74995Z"
      fill="currentColor"
    />
    <path
      d="M7.0002 8.74999C6.67754 8.74999 6.41641 8.48885 6.41641 8.1662C6.41641 7.43475 6.80879 6.7744 7.43906 6.44081C7.75215 6.27538 8.02148 5.88846 7.91895 5.39901C7.84512 5.04764 7.56074 4.7619 7.20937 4.68944C6.9168 4.62792 6.63105 4.69491 6.40684 4.87811C6.18535 5.05858 6.0582 5.32382 6.0582 5.60956C6.0582 5.93221 5.79707 6.19335 5.47441 6.19335C5.15176 6.19335 4.89062 5.93221 4.89062 5.60956C4.89062 4.97245 5.175 4.37636 5.66992 3.97304C6.16484 3.57108 6.81289 3.41522 7.4459 3.54784C8.24434 3.71464 8.89375 4.36268 9.06055 5.16249C9.25605 6.10038 8.82402 7.03007 7.9832 7.47303C7.73574 7.60428 7.58125 7.87089 7.58125 8.16757C7.58398 8.48886 7.32285 8.74999 7.0002 8.74999Z"
      fill="currentColor"
    />
    <path
      d="M6.41602 9.91619C6.41602 10.071 6.47752 10.2195 6.587 10.329C6.69649 10.4385 6.84497 10.5 6.9998 10.5C7.15464 10.5 7.30312 10.4385 7.41261 10.329C7.52209 10.2195 7.58359 10.071 7.58359 9.91619C7.58359 9.76136 7.52209 9.61287 7.41261 9.50339C7.30312 9.3939 7.15464 9.3324 6.9998 9.3324C6.84497 9.3324 6.69649 9.3939 6.587 9.50339C6.47752 9.61287 6.41602 9.76136 6.41602 9.91619Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region + 加号图标
/** + 加号图标 */
export const PlusIconSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M8.33301 2C8.51699 2 8.66682 2.14906 8.66699 2.33301V7.33301H13.667C13.8509 7.33318 14 7.48301 14 7.66699V8.33301C14 8.51699 13.8509 8.66584 13.667 8.66602H8.66699V13.667C8.66682 13.8509 8.51699 14 8.33301 14H7.66699C7.48301 14 7.33318 13.8509 7.33301 13.667V8.66602H2.33301C2.14906 8.66584 2 8.51699 2 8.33301V7.66699C2 7.48301 2.14906 7.33318 2.33301 7.33301H7.33301V2.33301C7.33318 2.14906 7.48301 2 7.66699 2H8.33301Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region + 加号图标 粗
/** + 加号图标  粗 */
export const PlusIconSvgBold = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path d="M5 3H8V5H5V8H3V5H0V3H3V0H5V3Z" fill="currentColor" />
  </svg>
);
// #endregion

// #region - 减号图标
/** - 减号图标   */
export const MinusIconSvg = ({ className }: { className?: string }) => (
  <svg
    width="8"
    height="2"
    viewBox="0 0 8 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
  >
    <rect width="8" height="1.5" fill="currentColor" />
  </svg>
);
// #endregion

// #region 镂空向左箭头，前往登录
/** 镂空向左箭头，前往登录 */
export const ArrowLeftCutoutSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M8 0.666992C12.05 0.66708 15.333 3.95 15.333 8C15.333 12.05 12.05 15.3329 8 15.333C3.94991 15.333 0.666016 12.0501 0.666016 8C0.66606 3.94995 3.94994 0.666992 8 0.666992ZM4.66699 8L7.9668 11.2998L8.90918 10.3574L7.21875 8.66699H11.333V7.33301H7.21875L8.90918 5.64258L7.9668 4.7002L4.66699 8Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 人像，游客进入
/** 人像，游客进入 */
export const PersonSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M4.80001 4.49951C4.80001 5.19175 5.00528 5.86844 5.38986 6.44401C5.77445 7.01958 6.32107 7.46818 6.96061 7.73309C7.60016 7.998 8.30389 8.06731 8.98282 7.93226C9.66176 7.79721 10.2854 7.46387 10.7749 6.97438C11.2644 6.4849 11.5977 5.86126 11.7328 5.18233C11.8678 4.50339 11.7985 3.79966 11.5336 3.16012C11.2687 2.52058 10.8201 1.97395 10.2445 1.58937C9.66893 1.20478 8.99224 0.999512 8.30001 0.999512C7.84038 0.999512 7.38525 1.09004 6.96061 1.26593C6.53598 1.44182 6.15014 1.69963 5.82513 2.02464C5.50013 2.34964 5.24232 2.73548 5.06643 3.16012C4.89054 3.58476 4.80001 4.03988 4.80001 4.49951ZM11.492 8.76951H11.205C11.086 8.77246 10.9689 8.80111 10.862 8.85351C10.862 8.85351 10.631 8.98651 10.421 9.07751C9.7557 9.35512 9.04191 9.49788 8.32101 9.49751C7.59966 9.50249 6.88495 9.35955 6.22101 9.07751C6.01101 8.98651 5.77301 8.85351 5.77301 8.85351C5.66773 8.79666 5.54964 8.76774 5.43001 8.76951H5.12901C4.52358 8.88003 3.95663 9.144 3.48234 9.53617C3.00805 9.92835 2.64228 10.4356 2.42001 11.0095C2.14138 11.7112 1.99884 12.4595 2.00001 13.2145C2.01212 13.3245 2.05017 13.4301 2.11101 13.5226C2.17185 13.6151 2.25376 13.6918 2.35001 13.7465C2.35001 13.7465 4.31001 14.9995 8.30001 14.9995C12.29 14.9995 14.25 13.7465 14.25 13.7465C14.3472 13.6912 14.4296 13.6133 14.4905 13.5196C14.5514 13.4258 14.589 13.3188 14.6 13.2075C14.6076 12.4646 14.4697 11.7274 14.194 11.0375C13.9808 10.4537 13.6198 9.93521 13.1462 9.53276C12.6725 9.13031 12.1026 8.85767 11.492 8.74151V8.76951Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 立即注册，前往注册
/** 立即注册，前往注册 */
export const ToRegisterSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M12.667 1.33301C12.8436 1.33314 13.0138 1.40341 13.1387 1.52832C13.2635 1.65326 13.3339 1.82341 13.334 2V14C13.3339 14.1764 13.2632 14.3458 13.1387 14.4707C13.0138 14.5956 12.8436 14.6659 12.667 14.666H3.33398C3.15723 14.666 2.98732 14.5957 2.8623 14.4707C2.73746 14.3458 2.66708 14.1766 2.66699 14V2C2.66706 1.82328 2.73734 1.65329 2.8623 1.52832C2.98729 1.40352 3.15735 1.33301 3.33398 1.33301H12.667ZM6.66699 12H9.33301V10.667H6.66699V12Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 圆圈+感叹号，提示icon
/** 圆圈+感叹号， 提示icon，感叹号向下 */
export const CircleExclamationSvg = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
  >
    <circle cx="8" cy="8" r="8" fill="url(#paint0_radial_11788_32511)" />
    <g clipPath="url(#clip0_11788_32511)">
      <path
        d="M7.99915 14.25C4.54727 14.25 1.74915 11.4519 1.74915 8C1.74915 4.54812 4.54727 1.75 7.99915 1.75C11.451 1.75 14.2491 4.54812 14.2491 8C14.2491 11.4519 11.451 14.25 7.99915 14.25ZM7.37415 9.875H8.62415V11.125H7.37415V9.875ZM7.37415 4.875H8.62415V8.625H7.37415V4.875Z"
        fill="#F7B500"
      />
      <path d="M8.62439 9.875H7.37439V11.125H8.62439V9.875Z" fill="white" />
      <path d="M8.62439 4.875H7.37439V8.625H8.62439V4.875Z" fill="white" />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_11788_32511"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.875 8) scale(12.125)"
      >
        <stop stopColor="#FEF1CD" />
        <stop offset="1" stopColor="#FCCF52" />
      </radialGradient>
      <clipPath id="clip0_11788_32511">
        <rect width="15" height="15" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
// #endregion

// #region 投注-确认中图标
/** 投注-确认中图标 */
export const BetConfirmingSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M10.0003 18.3337C5.39783 18.3337 1.66699 14.6028 1.66699 10.0003C1.66699 5.39783 5.39783 1.66699 10.0003 1.66699C14.6028 1.66699 18.3337 5.39783 18.3337 10.0003C18.3337 14.6028 14.6028 18.3337 10.0003 18.3337ZM10.0003 16.667C11.7684 16.667 13.4641 15.9646 14.7144 14.7144C15.9646 13.4641 16.667 11.7684 16.667 10.0003C16.667 8.23222 15.9646 6.53652 14.7144 5.28628C13.4641 4.03604 11.7684 3.33366 10.0003 3.33366C8.23222 3.33366 6.53652 4.03604 5.28628 5.28628C4.03604 6.53652 3.33366 8.23222 3.33366 10.0003C3.33366 11.7684 4.03604 13.4641 5.28628 14.7144C6.53652 15.9646 8.23222 16.667 10.0003 16.667ZM10.8337 10.0003H14.167V11.667H9.16699V5.83366H10.8337V10.0003Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 投注-失败图标
/** 投注-失败图标 */
export const BetFailedSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M10 1.6665C14.6022 1.6665 18.3327 5.3974 18.333 9.99951C18.333 14.6018 14.6023 18.3335 10 18.3335C5.39767 18.3335 1.66699 14.6018 1.66699 9.99951C1.66726 5.3974 5.39783 1.6665 10 1.6665ZM10 3.3335C6.31833 3.3335 3.33327 6.3179 3.33301 9.99951C3.33301 13.6813 6.31817 16.6665 10 16.6665C13.6818 16.6665 16.667 13.6813 16.667 9.99951C16.6667 6.3179 13.6817 3.3335 10 3.3335ZM13.5352 7.64307L11.1777 9.99951L13.5352 12.3569L12.3564 13.5356L10 11.1782L7.64258 13.5356L6.46387 12.3569L8.82129 9.99951L6.46387 7.64307L7.64258 6.46436L10 8.82178L12.3564 6.46436L13.5352 7.64307Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 投注-失败图标-pc
/** 投注-失败图标-pc */
export const BetFailedPCSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <circle cx="6.99935" cy="7.00033" r="5.83333" fill="currentColor" />
    <rect
      x="4.52539"
      y="8.64941"
      width="5.83333"
      height="1.16667"
      rx="0.583333"
      transform="rotate(-45 4.52539 8.64941)"
      fill="white"
    />
    <rect
      width="5.83333"
      height="1.16667"
      rx="0.583333"
      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 9.47461 8.64941)"
      fill="white"
    />
  </svg>
);
// #endregion

// #region 投注-成功图标
/** 投注-成功图标 */
export const BetSuccessSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M9.99984 18.3332C5.39734 18.3332 1.6665 14.6023 1.6665 9.99984C1.6665 5.39734 5.39734 1.6665 9.99984 1.6665C14.6023 1.6665 18.3332 5.39734 18.3332 9.99984C18.3332 14.6023 14.6023 18.3332 9.99984 18.3332ZM9.99984 16.6665C11.7679 16.6665 13.4636 15.9641 14.7139 14.7139C15.9641 13.4636 16.6665 11.7679 16.6665 9.99984C16.6665 8.23173 15.9641 6.53603 14.7139 5.28579C13.4636 4.03555 11.7679 3.33317 9.99984 3.33317C8.23173 3.33317 6.53603 4.03555 5.28579 5.28579C4.03555 6.53603 3.33317 8.23173 3.33317 9.99984C3.33317 11.7679 4.03555 13.4636 5.28579 14.7139C6.53603 15.9641 8.23173 16.6665 9.99984 16.6665Z"
      fill="currentColor"
    />
    <path
      d="M8.70283 13.5708L5.16699 10.035L6.34533 8.85667L8.70283 11.2142L13.4162 6.5L14.5953 7.67833L8.70283 13.5708Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 投注-成功图标 pc
/** 投注-成功图标 pc */
export const BetSuccessPCSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <circle cx="6.99935" cy="7.00033" r="5.83333" fill="currentColor" />
    <rect
      x="5.34814"
      y="8.89062"
      width="5.83333"
      height="1.16667"
      rx="0.583333"
      transform="rotate(-45 5.34814 8.89062)"
      fill="white"
    />
    <rect
      width="3.5"
      height="1.16667"
      rx="0.583333"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 3.69775 7.24023)"
      fill="white"
    />
  </svg>
);
// #endregion

// #region 公告 喇叭 图标
/** 公告 喇叭 图标 */
export const SpeakerSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <g clipPath="url(#clip0_39338_37056)">
      <path
        d="M3.5335 9.59904H1.2001C1.04097 9.59904 0.888355 9.53582 0.775834 9.4233C0.663312 9.31078 0.600098 9.15817 0.600098 8.99904V5.39904C0.600098 5.23991 0.663312 5.08729 0.775834 4.97477C0.888355 4.86225 1.04097 4.79904 1.2001 4.79904H3.5335L6.7099 2.19984C6.75385 2.1638 6.80713 2.141 6.86354 2.13407C6.91995 2.12715 6.97716 2.13639 7.02852 2.16071C7.07989 2.18504 7.12328 2.22346 7.15366 2.2715C7.18403 2.31953 7.20014 2.3752 7.2001 2.43204V11.966C7.20014 12.0229 7.18403 12.0785 7.15366 12.1266C7.12328 12.1746 7.07989 12.213 7.02852 12.2374C6.97716 12.2617 6.91995 12.2709 6.86354 12.264C6.80713 12.2571 6.75385 12.2343 6.7099 12.1982L3.5335 9.59904ZM11.6437 12.0794L10.7941 11.2298C11.3629 10.7237 11.8179 10.1028 12.1292 9.40805C12.4405 8.71326 12.601 7.96038 12.6001 7.19904C12.6008 6.39869 12.4233 5.60823 12.0804 4.88506C11.7375 4.16189 11.2378 3.52418 10.6177 3.01824L11.4697 2.16624C12.2008 2.78516 12.788 3.55613 13.1905 4.42535C13.593 5.29458 13.801 6.24115 13.8001 7.19904C13.8001 9.13284 12.9685 10.8722 11.6437 12.0794ZM9.5179 9.95364L8.6647 9.10044C8.95598 8.87646 9.19184 8.58848 9.35404 8.25878C9.51624 7.92907 9.60043 7.56648 9.6001 7.19904C9.6001 6.34104 9.1501 5.58804 8.4721 5.16384L9.3355 4.30044C9.78997 4.63475 10.1594 5.07135 10.4138 5.57491C10.6682 6.07847 10.8006 6.63485 10.8001 7.19904C10.8001 8.30424 10.3021 9.29304 9.5179 9.95364Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_39338_37056">
        <rect width="14.4" height="14.4" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
// #endregion

// #region 侧边竖线 2 x 16
/** 注单-标题栏-侧边竖线 2 x 16 */
export const LeftLine2x16Svg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2"
    height="16"
    viewBox="0 0 2 16"
    fill="none"
    className={cn('shrink-0 w-[2px] h-[16px]', className)}
  >
    <path
      d="M0 0L1.44721 0.723607C1.786 0.892999 2 1.23926 2 1.61803V14.382C2 14.7607 1.786 15.107 1.44721 15.2764L0 16V0Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 侧边竖线 2 x 18
/** 购物车-标题栏-侧边竖线 2 x 18 */
export const LeftLine2x18Svg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2"
    height="18"
    viewBox="0 0 2 18"
    fill="none"
    className={cn('shrink-0 w-[2px] h-[18px]', className)}
  >
    <path
      d="M0 0L0.70763 0.489897C1.51702 1.05025 2 1.97204 2 2.95647V15.0435C2 16.028 1.51702 16.9498 0.70763 17.5101L0 18V0Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 返回导航 箭头
/** 返回导航 箭头 */
export const BackMenuArrowSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.85035 0.146447C3.04561 -0.0488155 3.36212 -0.0488156 3.55738 0.146447C3.7526 0.341712 3.75263 0.65823 3.55738 0.853478L1.58277 2.82809H7.20484C9.13763 2.82833 10.7048 4.39524 10.7048 6.32809C10.7048 8.26093 9.13763 9.82784 7.20484 9.82809H1.20484C0.9287 9.82809 0.704842 9.60423 0.704842 9.32809C0.704842 9.05194 0.9287 8.82809 1.20484 8.82809H7.20484C8.58534 8.82784 9.70484 7.70865 9.70484 6.32809C9.70484 4.94753 8.58534 3.82833 7.20484 3.82809H1.58277L3.55738 5.8027C3.75263 5.99794 3.7526 6.31446 3.55738 6.50973C3.36212 6.70499 3.04561 6.70499 2.85035 6.50973L0.234139 3.89352C-0.0780466 3.58114 -0.0780463 3.07503 0.234139 2.76266L2.85035 0.146447Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 输入框清除 X
/** 输入框清除 X  */
export const ClearInputXSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M5 0C2.21429 0 0 2.21429 0 5C0 7.78571 2.21429 10 5 10C7.78571 10 10 7.78571 10 5C10 2.21429 7.78571 0 5 0ZM6.92857 7.5L5 5.57143L3.07143 7.5L2.5 6.92857L4.42857 5L2.5 3.07143L3.07143 2.5L5 4.42857L6.92857 2.5L7.5 3.07143L5.57143 5L7.5 6.92857L6.92857 7.5Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 三角形 向上
/** 三角形 向上   */
export const TriangleUpSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M2.77985 7.52518C2.46557 7.91804 2.74527 8.5 3.24837 8.5H8.75163C9.25473 8.5 9.53443 7.91804 9.22015 7.52518L6.46852 4.08565C6.22833 3.78541 5.77167 3.78541 5.53148 4.08565L2.77985 7.52518Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 赔率升降箭头
/** 赔率升降箭头   */
export const OddsChangeArrowSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M3.66023 0.136697L0.0143918 9.03253C-0.0585249 9.21482 0.160225 9.39712 0.342517 9.28774L3.73314 7.90232C3.80606 7.82941 3.91543 7.82941 3.98835 7.90232L7.37898 9.28774C7.56127 9.43357 7.78002 9.25128 7.7071 9.03253L4.06127 0.136697C3.95189 -0.0455942 3.73314 -0.0455942 3.66023 0.136697Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 暂无数据
/** 暂无数据   */
export const EmptyDataSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M3 6C3.0001 4.34334 4.34336 3.00018 6 3L30 3C31.6568 3 32.9999 4.34323 33 6V8.80469C32.1173 8.29387 31.0932 8 30 8L6 8C4.90678 8 3.88272 8.29387 3 8.80469V6Z"
      fill="currentColor"
    />
    <path
      d="M3 14C3.00013 12.3433 4.34328 11.0001 6 11H30C31.6568 11 32.9999 12.3433 33 14V30.001C32.9999 31.6577 31.6568 33.001 30 33.001H6C4.34328 33.0009 3.00013 31.6577 3 30.001L3 14ZM22.5 27.75H25.5V20.25H22.5V27.75ZM16.5 27.75H19.5V15.75H16.5V27.75ZM10.5 27.75H13.5V18.75H10.5V27.75Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 暂无活动
/** 暂无活动   */
export const EmptyActivitySvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M31.5009 3.75061C33.1577 3.7507 34.5009 5.09381 34.5009 6.75061V27.7506C34.5007 29.3686 33.2194 30.687 31.6162 30.7477C31.9577 29.6867 32.0091 28.5186 31.6992 27.3619L25.373 3.75061H31.5009Z"
      fill="currentColor"
    />
    <path
      d="M18.9851 2.12558C20.5855 1.69675 22.2305 2.6465 22.6593 4.2469L24.212 10.0415C23.0125 10.3635 22.3009 11.5972 22.6219 12.7969C22.9435 13.9969 24.1764 14.7082 25.3764 14.3872L28.871 27.4291C29.2998 29.0295 28.3501 30.6745 26.7497 31.1033L10.8119 35.3739C9.21156 35.8025 7.56646 34.8529 7.13765 33.2525L3.64454 20.2123C4.84469 19.8906 5.55712 18.6568 5.23553 17.4566C4.91382 16.2566 3.67904 15.5444 2.47891 15.8659L0.925993 10.0703C0.497188 8.47 1.44705 6.82501 3.04731 6.39609L18.9851 2.12558ZM8.32648 17.4049L12.6731 16.2402L12.2849 14.7913L7.93825 15.956L8.32648 17.4049ZM15.5709 15.4637L19.9176 14.299L19.5294 12.8501L15.1827 14.0148L15.5709 15.4637Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 暂无盘口
/** 暂无盘口   */
export const EmptyOddsSvg = ({ className }: { className?: string }) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7406 3.07429C16.8186 2.68194 18.012 3.23875 18.4047 4.31648L22.0639 14.3712H4.70449L3.07559 9.89558C2.68393 8.81787 3.24039 7.62511 4.31777 7.23249L7.47598 6.08308C7.98945 7.49356 9.54974 8.22187 10.9604 7.70905C12.3711 7.19557 13.0986 5.63452 12.5854 4.2237L15.7406 3.07429ZM29.7318 3.7237C31.1338 3.7237 32.2702 4.86092 32.2709 6.26276V14.3712H24.9555L21.0805 3.7237H29.7318Z"
      fill="currentColor"
    />
    <path
      d="M2.36817 17.9956C2.36817 17.2449 2.97677 16.6363 3.7275 16.6363H32.2735C33.0242 16.6363 33.6328 17.2449 33.6328 17.9956V30.2296C33.6328 31.7311 32.4156 32.9482 30.9141 32.9482H5.08684C3.58536 32.9482 2.36817 31.7311 2.36817 30.2296V17.9956Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 暂无收藏
/** 暂无收藏   */
export const EmptyCollectionSvg = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M3.00018 6.00037C3.00018 4.34351 4.34333 3.00037 6.00018 3.00037L30.0002 3.00037C31.657 3.00037 33.0002 4.34351 33.0002 6.00037V8.22205C32.2825 7.9186 31.4934 7.75037 30.6652 7.75037L5.33221 7.75037C4.50516 7.75037 3.71706 7.91743 3.00018 8.22009V6.00037Z"
      fill="currentColor"
    />
    <path
      d="M3.00018 24.0004C4.24271 24.0003 5.25005 22.9929 5.25018 21.7504C5.25018 20.5077 4.2428 19.5004 3.00018 19.5004L3.00018 13.5004C3.00018 11.8435 4.34333 10.5004 6.00018 10.5004H30.0002C31.657 10.5004 33.0002 11.8435 33.0002 13.5004V19.5004C31.7576 19.5004 30.7502 20.5078 30.7502 21.7504C30.7503 22.9929 31.7577 24.0003 33.0002 24.0004V30.0004C33.0002 31.6572 31.657 33.0004 30.0002 33.0004H6.00018C4.34333 33.0004 3.00018 31.6572 3.00018 30.0004L3.00018 24.0004ZM13.9504 20.4535C13.5797 20.4975 13.4304 20.9559 13.7043 21.2094L15.6047 22.9662L15.1008 25.5052C15.0283 25.8713 15.4177 26.1543 15.7433 25.972L18.0012 24.7074L20.259 25.972C20.5846 26.1543 20.9748 25.8712 20.9025 25.5052L20.3976 22.9662L22.298 21.2094C22.5718 20.956 22.4233 20.4977 22.0529 20.4535L19.4826 20.1488L18.3986 17.7992C18.2422 17.4602 17.7601 17.4602 17.6037 17.7992L16.5197 20.1488L13.9504 20.4535Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion

// #region 暂无搜索结果
/** 暂无搜索结果   */
export const EmptySearchResultSvg = ({ className }: { className?: string }) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx('shrink-0', className)}
  >
    <path
      d="M3 6C3.0001 4.34334 4.34336 3.00018 6 3L30 3C31.6568 3 32.9999 4.34323 33 6V8.80469C32.1173 8.29387 31.0932 8 30 8L6 8C4.90678 8 3.88272 8.29387 3 8.80469V6Z"
      fill="currentColor"
    />
    <path
      d="M3 14C3.00013 12.3433 4.34328 11.0001 6 11H30C31.6568 11 32.9999 12.3433 33 14V30.001C32.9999 31.6577 31.6568 33.001 30 33.001H6C4.34328 33.0009 3.00013 31.6577 3 30.001L3 14ZM11.5625 20.625C11.5625 23.4209 13.8291 25.6875 16.625 25.6875C17.6154 25.6875 18.538 25.4008 19.3184 24.9092L22.3389 27.9287L23.9297 26.3379L20.9102 23.3184C21.4016 22.5381 21.6875 21.6152 21.6875 20.625C21.6875 17.8291 19.4209 15.5625 16.625 15.5625C13.8291 15.5625 11.5625 17.8291 11.5625 20.625ZM13.8125 20.625C13.8125 19.0717 15.0717 17.8125 16.625 17.8125C18.1783 17.8125 19.4375 19.0717 19.4375 20.625C19.4375 22.1783 18.1783 23.4375 16.625 23.4375C15.0717 23.4375 13.8125 22.1783 13.8125 20.625Z"
      fill="currentColor"
    />
  </svg>
);
// #endregion
